import { defineComponent } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  setup() {
    const router = useRouter();
    const menuItemList = router.getRoutes().filter(v => v.meta.isShow);
    return {
      menuItemList
    };
  }
});